import React from 'react';
import { Pagination, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { styled } from '@mui/system';
import { Box } from '@mui/material';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import Data from '../Data/PersonalInfo.json';
import ProjectsCard from './ProjectsCard';

// Custom MUI components
const Item = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: theme.spacing(4),
}));

// Prev Button for navigating projects
const PrevButton = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  top: '50%',
  transform: 'translateY(-50%) translateX(-10%)',
  zIndex: 1,
  cursor: 'pointer',
  color: theme.palette.primary.main,
}));

// Next Button for navigating Projects
const NextButton = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)translateX(10%)',
  zIndex: 1,
  cursor: 'pointer',
  color: theme.palette.primary.main,
}));

const ProjectsCarousel = () => {
  // getting projects data
  const projects = Data.projects;

  return (
    <Swiper
      modules={[Pagination, Navigation]}
      slidesPerView={1}
      spaceBetween={10}
      loop={true}
      pagination={{
        clickable: true,
      }}
      navigation={{
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      }}
      className='mySwiper'
      breakpoints={{
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        800: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1440: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      }}
    >
      <PrevButton className='swiper-button-prev' />
      <NextButton className='swiper-button-next' />
      {projects.map((data) => (
        <SwiperSlide key={data.title}>
          <Item>
            <ProjectsCard project={data} />
          </Item>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ProjectsCarousel;
